/**
 * Workflow · UI primitives shared by MyRequests + Approvals Queue.
 *
 * Kept intentionally lightweight — the workflow surfaces are small
 * enough that a dedicated helper module beats a full feature-slice.
 */
import { Badge } from "../../components/ui/badge";


export const STATUS_LABELS = {
    pending: { label: "Pending Approval", tone: "amber" },
    pending_s1: { label: "Pending Approval", tone: "amber" },
    approved: { label: "Approved", tone: "emerald" },
    rejected: { label: "Rejected", tone: "red" },
    withdrawn: { label: "Withdrawn", tone: "slate" },
    override_active: { label: "Emergency Created", tone: "purple" },
};


const TONE_CLASSES = {
    amber: "bg-amber-100 text-amber-800 border-amber-300",
    emerald: "bg-emerald-100 text-emerald-800 border-emerald-300",
    red: "bg-red-100 text-red-800 border-red-300",
    slate: "bg-slate-100 text-slate-700 border-slate-300",
    purple: "bg-purple-100 text-purple-800 border-purple-300",
};


export function WorkflowStatusBadge({ status }) {
    const spec = STATUS_LABELS[status] || { label: status, tone: "slate" };
    return (
        <Badge
            variant="outline"
            className={TONE_CLASSES[spec.tone]}
            data-testid={`wf-status-${status}`}
        >
            {spec.label}
        </Badge>
    );
}


export function formatDT(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleString();
    } catch {
        return iso;
    }
}


/** Human label for a workflow-history event. */
export const EVENT_LABEL = {
    initiate: "Request submitted",
    approve: "Approved",
    reject: "Rejected",
    withdraw: "Withdrawn by initiator",
    emergency_override: "Emergency override invoked",
    notification_attempt: "Notification dispatched",
};
